import { IGetProdutosServicosDropDownUseCase } from "../../../presentation/useCases/read/get_produtos_servicos_drop_down_use_case";
import { ProdutoServicoDropDown } from "../../models/produto_servico_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetProdutosServicosDropDownUseCase
 */

export class GetProdutosServicosDropDownUseCase implements IGetProdutosServicosDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getProdutosServicosDropDown(
    filtrarTipo: string | undefined,
    incluirIdProdutoServico: number | undefined,
    incluirCodigoDescricao: boolean | undefined,
  ): Promise<ProdutoServicoDropDown[]> {
    return await this.repository.getProdutosServicosDropDown(
      filtrarTipo ?? null,
      incluirIdProdutoServico ?? null,
      incluirCodigoDescricao ?? null,
    );
  }
}
